var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 33,
    viewBox: "0 0 40 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 16.5C0 7.66344 7.16344 0.5 16 0.5H24C32.8366 0.5 40 7.66344 40 16.5C40 25.3366 32.8366 32.5 24 32.5H16C7.16344 32.5 0 25.3366 0 16.5Z",
    fill: "#F6F9FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 12C15 12 13 16.5 13 16.5C13 16.5 15 21 20 21C25 21 27 16.5 27 16.5C27 16.5 25 12 20 12Z",
    stroke: "#050F4E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18.5C21.1046 18.5 22 17.6046 22 16.5C22 15.3954 21.1046 14.5 20 14.5C18.8954 14.5 18 15.3954 18 16.5C18 17.6046 18.8954 18.5 20 18.5Z",
    stroke: "#050F4E",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.faa37c064702b5ad4e7a35504b798f40.svg";
export { ForwardRef as ReactComponent };